import gatewayPaymentServices from "services/PaymentgatewayServices";
import useToggleDrawer from 'hooks/useToggleDrawer';
import PageTitle from 'components/Typography/PageTitle';
import MainDrawer from 'components/drawer/MainDrawer';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import { useContext, useEffect, useState } from 'react';
import { SidebarContext } from 'context/SidebarContext';
import { FiRefreshCcw } from 'react-icons/fi';
import DeleteModal from 'components/modal/DeleteModal';
import useAsync from 'hooks/useAsync';

import {
    Card,
    CardBody,
    Input,
    Table,
    TableCell,
    TableContainer,
    TableHeader,
} from '@windmill/react-ui';

import PaymentGatewayTable from 'components/PaymentGateway/Paymentgatewaytable';
import PaymentGatewayDrawer from 'components/drawer/PaymentgatewayDrawer';
import sidebar from 'routes/sidebar';
import ExportDataXlsx from 'components/common/ExportDataXlsx';

const Gatewaymethod = () => {
    const { title, serviceId } = useToggleDrawer();
    const { isUpdate, setIsUpdate } = useContext(SidebarContext);

    const [status, setStatus] = useState(false);
    const [searchText, setSearchText] = useState('');

    const adminInfo = localStorage.getItem('adminInfo')
        ? JSON.parse(localStorage.getItem('adminInfo'))
        : null;

    const { data = {}, loading, error } = useAsync(() =>
        gatewayPaymentServices.getAllGatewaypayment(), [isUpdate]
    );


    const isAdmin = adminInfo?.id === 1;

    const hideView = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'gateway method' && perm.view === 1
        );

    const hideDelete = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'gateway method' && perm.delete === 1
        );

    const hideEdit = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'gateway method' && perm.edit === 1
        );

    const hideExport = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'gateway method' && perm.export === 1
        );

    useEffect(() => {
        setStatus(data?.status || false);
    }, [data?.status]);
    useEffect(() => {
        if (isUpdate) {
            setIsUpdate(false);
        }
    }, [isUpdate, setIsUpdate]);
    const handleRefresh = () => {
        setIsUpdate(true);
    };

    const filteredData =
        searchText.trim() === ""
            ? data?.data
            : data?.data?.filter((item) => {
                const text = searchText.toLowerCase();

                return (
                    item.gateway_name.toLowerCase().includes(text) ||
                    item.payment_types.some((m) =>
                        m.toLowerCase().includes(text)
                    ) ||
                    Object.values(item.charges).some((c) =>
                        String(c).includes(text)
                    )
                );
            });

    const finalData = filteredData?.flatMap((item, itemIndex) =>
        item.payment_types.map((method, methodIndex) => ({
            "SI.No": methodIndex === 0 ? itemIndex + 1 : "",
            "Gateway name": item.gateway_name,
            "Payment Method": method,
            "Tax": item.charges[method],
        }))
    );

    return (
        <>
            {hideView && (
                <>
                    <DeleteModal id={serviceId} title={title} />
                    <PageTitle sidebar={sidebar().sidebar} />

                    <MainDrawer>
                        <PaymentGatewayDrawer id={serviceId} />
                    </MainDrawer>

                    <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
                        <CardBody>
                            <form className="gap-6 flex items-center">
                                <div className="flex-1">
                                    <Input
                                        className="border h-10 text-sm focus:outline-none block w-full bg-gray-100"
                                        type="search"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder="Quick Search"
                                    />
                                </div>

                                {hideExport && (
                                    <ExportDataXlsx
                                        title="Payment Method List"
                                        exportDataXlsx={finalData}
                                        fileNames="Payment Method List"
                                    />
                                )}

                                <FiRefreshCcw
                                    onClick={handleRefresh}
                                    cursor="pointer"
                                />
                            </form>
                        </CardBody>
                    </Card>

                    <DataWrapper loading={loading} error={error} status={status}>
                        {filteredData?.length > 0 ? (
                            <TableContainer
                                className="mb-8"
                                style={{ maxHeight: '65vh', overflowY: 'scroll' }}
                            >
                                <Table>
                                    <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                                        <tr className="bg-gray-100 dark:bg-gray-700">
                                            <TableCell className="text-center">Sl.No.</TableCell>
                                            <TableCell className="text-center">GateWay Type</TableCell>
                                            <TableCell className="text-center">Payment Methods</TableCell>
                                            <TableCell className="text-center">Tax</TableCell>
                                            <TableCell className="text-center">Actions</TableCell>
                                        </tr>
                                    </TableHeader>

                                    <PaymentGatewayTable
                                        paymentgatewaydata={filteredData}
                                        hideEdit={hideEdit}
                                        hideDelete={hideDelete}
                                    />
                                </Table>
                            </TableContainer>
                        ) : (
                            <NotFound title="There are no Payment gateways." />
                        )}
                    </DataWrapper>
                </>
            )}
        </>
    );
};

export default Gatewaymethod;
